import chunk from 'lodash/chunk';
import { toast } from '../components/ToastContainer';

class BatchError extends Error {
  constructor(failCount, totalCount) {
    super(`BatchError: ${failCount} of ${totalCount} failed`);
    this.failCount = failCount;
    this.totalCount = totalCount;
  }
}

async function batchFetch(fetch, inputArray, { batchSize = 1000, toastMessage = 'Updating' } = {}) {
  if (inputArray.length <= batchSize) {
    await fetch(inputArray);
  } else {
    const batches = chunk(inputArray, batchSize);
    let done = 0;
    let failed = 0;
    const toastId = Math.random();
    toast.info(`${toastMessage}: 0/${inputArray.length}`, { toastId, autoClose: false });
    const promises = batches.map(batch =>
      fetch(batch)
        .then(res => {
          done += batch.length;
          toast.info(`${toastMessage}: ${done}/${inputArray.length}`, {
            toastId,
            autoClose: false,
            dontJiggleOnUpdate: true,
          });
          return res;
        })
        .catch(err => {
          failed += batch.length;
          throw err;
        }),
    );

    await Promise.allSettled(promises).finally(() => {
      toast.dismiss(toastId);
    });
    if (failed) {
      throw new BatchError(failed, inputArray.length);
    }
  }

  return true;
}

export default batchFetch;
export { BatchError };
